import { type NodeData, nodeTypeIcons } from '@ipfabric/utils';
import { isNodeRenderable } from 'components/Graph/GraphApp/helpers/isNodeRenderable';
import type { GraphRendererPluginInterface } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';
import { identity, pipe } from 'fp-ts/lib/function';
import { shrinkBounds } from 'utils/pixi/shrinkBounds';

export interface IsNodeVisibleInViewportOptions {
  /**
   * Consider nodes too close to bounds not visible
   *
   * @see shrinkBounds
   */
  paddingFactor?: number;
}

export const isNodeVisibleInViewport =
  (
    pluginInterface: GraphRendererPluginInterface,
    options?: IsNodeVisibleInViewportOptions,
  ) =>
  (nodeData: NodeData): boolean => {
    if (!isNodeRenderable(pluginInterface, nodeData.id)) {
      return false;
    }

    const bounds = pipe(
      pluginInterface.viewport.getVisibleBounds(),
      options?.paddingFactor ? shrinkBounds(options?.paddingFactor) : identity,
    );

    const nodeSize = nodeTypeIcons[nodeData.type].getSize(nodeData.style);
    return (
      nodeData.position.x + nodeSize.width / 2 > bounds.x &&
      nodeData.position.x - nodeSize.width / 2 < bounds.x + bounds.width &&
      nodeData.position.y + nodeSize.height / 2 > bounds.y &&
      nodeData.position.y - nodeSize.height / 2 < bounds.y + bounds.height
    );
  };
